module.exports = __webpack_public_path__ + "static/media/service-img-20.eaa1804a.jpg";